import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Title from "./Title";
import { useSelector } from "react-redux";
import {
  filterOrders,
  getOrders,
  getOrdersBulk,
  sortOrders,
} from "../redux/dynamo_db/actions";
import {
  setParameters,
  removeParameter,
  clearParameters,
  setDateParameters,
} from "../redux/global/actions";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import MultiValueInput from "../inputs/multiValueInput";
import {
  Fab,
  Grid,
  Menu,
  MenuItem,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useEffect } from "react";
import "./Contracts.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import "./Orders.css";
import SearchDateInput from "../inputs/searchDateInput";
import MultiSelector from "../inputs/MultiSelector";
import {
  downloadCSV,
  downloadJSON,
  extractUserInfoFromToken,
  getLocalStorageSAMLToken,
} from "../utils";

export default function Orders() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openBulkConfirmation, setOpenBulkConfirmation] = React.useState(false);
  const [openBulkMessage, setOpenBulkMessage] = React.useState(false);
  const queryParameters = useSelector((state) => state?.parameters?.orders);

  const [currentOrderId, setCurrentOrderId] = React.useState();
  const [currentOrderLine, setCurrentOrderLine] = React.useState();
  const [currentPartNumber, setCurrentPartNumber] = React.useState();

  const [filterOrderId, setFilterOrderId] = React.useState([]);
  const [filterOrderLine, setFilterOrderLine] = React.useState([]);
  const [filterSoldTo, setFilterSoldTo] = React.useState([]);
  const [filterPartNumber, setFilterPartNumber] = React.useState([]);
  const [filterPartDescription, setFilterPartDescription] = React.useState([]);

  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 100; // or any number you prefer

  const orders = useSelector((state) => {
    if (state.filteredOrders) {
      return state.filteredOrders.map((order) => {
        return {
          order_id: order.order_id,
          order_line: order.order_line,
          sold_to: order?.sold_to,
          part_number: order?.part_number,
          part_description: order?.part_description,
          document_type: order?.order_line_type_id,
          quantity: order?.quantity,
          order_date: order?.order_date,
        };
      });
    } else return [];
  });
  const total_orders = useSelector((state) => {
    if (state.total_orders) {
      return state.total_orders;
    }
  });
  // Slice the orders for the current page
  const paginatedOrders = orders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );
  const totalPages = Math.ceil(orders.length / itemsPerPage);

  const handleNextPage = () => {
    if (orders.length >= itemsPerPage * currentPage) {
      if (orders.length === currentPage * itemsPerPage) {
        handleExecuteSearch(currentPage + 1);
      } else {
        setCurrentPage((prev) => prev + 1);
      }
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };
  const handleExecuteSearch = (pageNumber = 1) => {
    setCurrentPage(pageNumber);

    let queryObject = {
      page: pageNumber,
      limit: itemsPerPage,
    };
    if (queryParameters?.orderIds) {
      queryObject.order_id = queryParameters?.orderIds;
    }
    if (queryParameters?.orderLines) {
      queryObject.order_line = queryParameters?.orderLines;
    }
    if (
      queryParameters?.documentTypes &&
      queryParameters?.documentTypes.length > 0
    ) {
      queryObject.document_types = queryParameters?.documentTypes;
    }
    if (
      queryParameters?.partNumbers &&
      queryParameters?.partNumbers.length > 0
    ) {
      queryObject.part_numbers = queryParameters?.partNumbers;
    }
    if (
      queryParameters?.creationDateStart &&
      queryParameters?.creationDateEnd
    ) {
      queryObject.extract_date_from = queryParameters?.creationDateStart;
      queryObject.extract_date_to = queryParameters?.creationDateEnd;
    }
    dispatch(getOrders(queryObject));
  };
  const handleExecuteBulkSearch = () => {
    let queryObject = {
      bulk: true,
    };

    if (queryParameters?.orderIds) {
      queryObject.order_id = queryParameters?.orderIds;
    }
    if (queryParameters?.orderLines) {
      queryObject.order_line = queryParameters?.orderLines;
    }
    if (
      queryParameters?.documentTypes &&
      queryParameters?.documentTypes.length > 0
    ) {
      queryObject.document_types = queryParameters?.documentTypes;
    }
    if (
      queryParameters?.partNumbers &&
      queryParameters?.partNumbers.length > 0
    ) {
      queryObject.part_numbers = queryParameters?.partNumbers;
    }
    if (
      queryParameters?.creationDateStart &&
      queryParameters?.creationDateEnd
    ) {
      queryObject.start_period = queryParameters?.creationDateStart;
      queryObject.end_period = queryParameters?.creationDateEnd;
    }

    const saml_token = getLocalStorageSAMLToken();
    const infoToken = extractUserInfoFromToken(saml_token);
    queryObject.email = infoToken.email;
    queryObject.request_user = infoToken.username;
    dispatch(getOrdersBulk(queryObject));
  };

  const handleExecuteFilter = () => {
    let filterObject = {};
    if (filterOrderId?.length > 0) {
      filterObject.orderId = [filterOrderId];
    }
    if (filterOrderLine?.length > 0) {
      filterObject.orderLine = [filterOrderLine];
    }
    if (filterSoldTo?.length > 0) {
      filterObject.soldTo = [filterSoldTo];
    }
    if (filterPartNumber?.length > 0) {
      filterObject.partNumber = [filterPartNumber];
    }
    if (filterPartDescription?.length > 0) {
      filterObject.partDescription = [filterPartDescription];
    }
    dispatch(filterOrders(filterObject));
  };

  useEffect(() => {
    handleExecuteFilter();
  }, [
    filterOrderId,
    filterOrderLine,
    filterSoldTo,
    filterPartNumber,
    filterPartDescription,
  ]);

  function handleSelectOrder(orderId, orderLine) {
    navigate("/orders/details/" + orderId + "/" + orderLine);
  }

  const handleDeleteOrderID = (chipToDelete) => () => {
    dispatch(removeParameter({ orders: { orderIds: [chipToDelete] } }));
  };
  const handleClearOrderIds = () => {
    dispatch(clearParameters({ orders: "orderIds" }));
  };
  const handleDeleteOrderLine = (chipToDelete) => () => {
    dispatch(removeParameter({ orders: { orderLines: [chipToDelete] } }));
  };
  const handleDeleteOrderLines = () => {
    dispatch(clearParameters({ orders: "orderLines" }));
  };
  const handleDeletePartNumber = (chipToDelete) => () => {
    dispatch(removeParameter({ orders: { partNumbers: [chipToDelete] } }));
  };
  const handleClearPartNumber = () => {
    dispatch(clearParameters({ orders: "partNumbers" }));
  };
  const handleDeleteDocumentType = (chipToDelete) => () => {
    dispatch(removeParameter({ orders: { documentTypes: [chipToDelete] } }));
  };
  const handleClearDocumentTypes = () => {
    dispatch(clearParameters({ orders: "documentTypes" }));
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(document.getElementById("menuAnchor"));
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterDescription =
    "Add filters to the list of results, and export the filtered list to CSV (currently not implemented for orders)";

  const [sortDirection, setSortDirection] = React.useState("");
  const [sortParameter, setSortParameter] = React.useState("");

  const handleSortOrders = (sortParameter) => {
    setSortParameter(sortParameter);
    if (sortDirection === "") {
      setSortDirection("ascending");
      dispatch(sortOrders(sortParameter, "ascending"));
    } else if (sortDirection === "ascending") {
      setSortDirection("descending");
      dispatch(sortOrders(sortParameter, "descending"));
    } else {
      setSortDirection("ascending");
      dispatch(sortOrders(sortParameter, "ascending"));
    }
  };

  const handleKeydown = (event) => {
    if (event.key == "Enter") {
      event.stopPropagation();
      event.preventDefault();
      setTimeout(() => {
        handleExecuteSearch(1);
      }, 0);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown);
    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  const handleExport = (orders, format = "csv") => {
    const fields = [
      { name: "order_id" },
      { name: "order_line" },
      { name: "order_date" },
      { name: "part_description" },
      { name: "part_number" },
      { name: "sold_to" },
    ];

    if (format === "csv") {
      downloadCSV(fields, "orders_export", ",", orders);
    } else {
      downloadJSON(fields, "orders_export", orders);
    }
  };

  return (
    <React.Fragment>
      <Modal
        open={openBulkMessage}
        style={{ textAlign: "center", paddingTop: "45vh" }}
      >
        <>
          <Typography style={{ color: "white" }}>
            Your query has been sent. You can follow the status in the Bulk
            Report page or wait for the Rainbow message that will announce the
            end of the export.
          </Typography>
          <div style={{ paddingBottom: "1%" }} />
          <Grid container className="headercontainer">
            <Grid item>
              <Button
                style={{ color: "white", background: "#6b469e" }}
                onClick={() => setOpenBulkMessage(false)}
              >
                Ok
              </Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <Modal
        open={openBulkConfirmation}
        style={{ textAlign: "center", paddingTop: "45vh" }}
      >
        <>
          <Typography style={{ color: "white" }}>
            This query could take a few minutes, are you sure you want to
            continue?
          </Typography>
          <div style={{ paddingBottom: "1%" }} />
          <Grid container className="headercontainer">
            <Grid item>
              <Button
                style={{ color: "white", background: "#6b469e" }}
                onClick={() => {
                  handleExecuteBulkSearch();
                  setOpenBulkConfirmation(false);
                  setOpenBulkMessage(true);
                }}
              >
                Yes
              </Button>
            </Grid>
            <Grid item style={{ width: "7%" }} />
            <Grid item>
              <Button
                style={{ color: "white", background: "#6b469e" }}
                onClick={() => setOpenBulkConfirmation(false)}
              >
                No
              </Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <MultiValueInput
        setCurrentParam={setCurrentOrderId}
        setQueryParams={setParameters}
        currentParam={currentOrderId}
        queryParams={queryParameters?.orderIds}
        handleDelete={handleDeleteOrderID}
        handleClear={handleClearOrderIds}
        label="Order ID"
        family="orders"
        type="orderIds"
      />
      <MultiValueInput
        setCurrentParam={setCurrentOrderLine}
        setQueryParams={setParameters}
        currentParam={currentOrderLine}
        queryParams={queryParameters?.orderLines}
        handleDelete={handleDeleteOrderLine}
        handleClear={handleDeleteOrderLines}
        label="Order Line"
        family="orders"
        type="orderLines"
      />
      <MultiValueInput
        setCurrentParam={setCurrentPartNumber}
        setQueryParams={setParameters}
        currentParam={currentPartNumber}
        queryParams={queryParameters?.partNumbers}
        handleDelete={handleDeletePartNumber}
        handleClear={handleClearPartNumber}
        label="Part Number"
        family="orders"
        type="partNumbers"
      />
      <MultiSelector
        setQueryParams={setParameters}
        queryParams={queryParameters?.documentTypes}
        handleDelete={handleDeleteDocumentType}
        handleClear={handleClearDocumentTypes}
        label="Order line type ID"
        family="orders"
        type="documentTypes"
        options={documentTypeValues}
      />
      <Grid>
        <SearchDateInput
          title={"Order Date"}
          setFilterDate={setDateParameters}
          family="orders"
          type="creationDateStart"
          type2="creationDateEnd"
        />
      </Grid>
      <Grid
        container
        style={{
          justifyContent: "center",
        }}
      >
        <Grid item>
          <Button
            variant="contained"
            onClick={() => handleExecuteSearch(1)}
            style={{ width: "15vw" }}
          >
            Search
          </Button>
        </Grid>
        <div style={{ paddingLeft: "0.2%" }} />
        <Grid item>
          <Button
            variant="contained"
            onClick={() => setOpenBulkConfirmation(true)}
            style={{ width: "15vw" }}
          >
            Bulk Export
          </Button>
        </Grid>
      </Grid>
      <Title>Orders</Title>
      <Typography>
        {orders?.length
          ? orders.length >= itemsPerPage * totalPages &&
            itemsPerPage !== total_orders
            ? orders?.length + " results, use pagination for more"
            : orders?.length + " results"
          : null}
      </Typography>
      {orders.length >= itemsPerPage && itemsPerPage !== total_orders && (
        <Grid container justifyContent="center" style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </Button>
          <Typography style={{ margin: "0 20px", alignSelf: "center" }}>
            Page {currentPage} of {totalPages}
          </Typography>
          <Button
            variant="contained"
            onClick={handleNextPage}
            disabled={orders.length < itemsPerPage * currentPage}
          >
            Next
          </Button>
        </Grid>
      )}
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Order ID"
                    variant="standard"
                    onChange={(e) => {
                      setFilterOrderId(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortOrders("order_id")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "order_id" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "order_id" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Order Line"
                    variant="standard"
                    onChange={(e) => {
                      setFilterOrderLine(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortOrders("order_line")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "order_line" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "order_line" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Sold To"
                    variant="standard"
                    onChange={(e) => {
                      setFilterSoldTo(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortOrders("sold_to")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "sold_to" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "sold_to" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Part Number"
                    variant="standard"
                    onChange={(e) => {
                      setFilterPartNumber(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortOrders("part_number")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "part_number" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "part_number" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Part Description"
                    variant="standard"
                    onChange={(e) => {
                      setFilterPartDescription(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortOrders("part_description")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "part_description" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "part_description" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Document type"
                    variant="standard"
                    onChange={(e) => {
                      setFilterPartDescription(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortOrders("order_line_type_id")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "order_line_type_id" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "order_line_type_id" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Quantity"
                    variant="standard"
                    onChange={(e) => {
                      setFilterPartDescription(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortOrders("quantity")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "quantity" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "quantity" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Order Date</Grid>
                <Grid item onClick={() => handleSortOrders("order_date")}>
                  {sortDirection === "ascending" &&
                  sortParameter === "order_date" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "order_date" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedOrders.map((row, i) => (
            <TableRow
              hover
              key={i + row?.order_id}
              onClick={() => handleSelectOrder(row?.order_id, row?.order_line)}
              style={{ cursor: "pointer" }}
            >
              <TableCell>{row?.order_id}</TableCell>
              <TableCell>{row?.order_line}</TableCell>
              <TableCell>{row?.sold_to}</TableCell>
              <TableCell>{row?.part_number}</TableCell>
              <TableCell>{row?.part_description}</TableCell>
              <TableCell>{row?.document_type}</TableCell>
              <TableCell>{row?.quantity}</TableCell>
              <TableCell>{row?.order_date}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {orders.length >= itemsPerPage && itemsPerPage !== total_orders && (
        <Grid container justifyContent="center" style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </Button>
          <Typography style={{ margin: "0 20px", alignSelf: "center" }}>
            Page {currentPage} of {totalPages}
          </Typography>
          <Button
            variant="contained"
            onClick={handleNextPage}
            disabled={orders.length < itemsPerPage * currentPage}
          >
            Next
          </Button>
        </Grid>
      )}
      <Tooltip
        title={<Typography fontSize={17}>{filterDescription}</Typography>}
      >
        <Fab
          style={{
            position: "absolute",
            right: 10,
            bottom: 10,
            backgroundColor: "#6b469e",
            color: "white",
            height: "5em",
            width: "5em",
          }}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <div
            id="menuAnchor"
            style={{
              position: "relative",
              bottom: 200,
              right: 250,
            }}
          ></div>
          <FileDownloadIcon
            fontSize="large"
            style={{ height: "70%", width: "70%" }}
          />
        </Fab>
      </Tooltip>
      <div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem>
            <TextField
              label="Order ID"
              onChange={(e) => {
                setFilterOrderId(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Order Line"
              onChange={(e) => {
                setFilterOrderLine(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <Button
              variant="contained"
              onClick={() => {
                handleExport(orders, "csv");
                handleClose();
              }}
            >
              Export as CSV
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              variant="contained"
              onClick={() => {
                handleExport(orders, "json");
                handleClose();
              }}
            >
              Export as JSON
            </Button>
          </MenuItem>
        </Menu>
      </div>
    </React.Fragment>
  );
}

const documentTypeValues = [
  "YAB",
  "YABG",
  "YABY",
  "YABZ",
  "YAD",
  "YADG",
  "YADY",
  "YADZ",
  "YAH",
  "YAHY",
  "YAHZ",
  "YAJ",
  "YAJY",
  "YAJZ",
  "YAK",
  "YAKG",
  "YAL",
  "YALG",
  "YAM",
  "YAM0",
  "YAM1",
  "YAN",
  "YANG",
  "YANV",
  "YANY",
  "YANZ",
  "YAP",
  "YAPG",
  "YAPU",
  "YAQ",
  "YAQG",
  "YAQU",
  "YAS",
  "YASG",
  "YASY",
  "YASZ",
  "YATX",
  "YAU",
  "YAX",
  "YAXG",
  "YAXU",
  "YAXW",
  "YAXY",
  "YAXZ",
  "YAY",
  "YAYG",
  "YAYU",
  "YAYV",
  "YAYY",
  "YAYZ",
  "YB1N",
  "YBB",
  "YBBG",
  "YBBY",
  "YBBZ",
  "YBD",
  "YBDG",
  "YBDY",
  "YBDZ",
  "YBF",
  "YBFG",
  "YBFY",
  "YBFZ",
  "YBH",
  "YBHG",
  "YBHY",
  "YBHZ",
  "YBP",
  "YBS",
  "YBT",
  "YBTG",
  "YBTY",
  "YBTZ",
  "YBU",
  "YBUG",
  "YBUY",
  "YBUZ",
  "YBX",
  "YBXG",
  "YBXU",
  "YBXV",
  "YBXY",
  "YBXZ",
  "YBY",
  "YBYG",
  "YBYU",
  "YBYV",
  "YBYY",
  "YBYZ",
  "YCA0",
  "YCG0",
  "YCM0",
  "YCM1",
  "YCM2",
  "YCM3",
  "YCM4",
  "YCM5",
  "YCM6",
  "YCM7",
  "YCM8",
  "YCM9",
  "YCMA",
  "YCMB",
  "YCMF",
  "YCMG",
  "YCMS",
  "YCMT",
  "YCMU",
  "YCMV",
  "YCN0",
  "YCN1",
  "YCP1",
  "YCQ0",
  "YCQ1",
  "YCQ2",
  "YCQ3",
  "YCS0",
  "YCS1",
  "YCS2",
  "YCS9",
  "YCU0",
  "YCU1",
  "YCS9",
  "YCU0",
  "YCU1",
  "YDDP",
  "YFAK",
  "YHBG",
  "YHBY",
  "YHDG",
  "YHDY",
  "YHFG",
  "YHFY",
  "YHIG",
  "YHXG",
  "YHXY",
  "YHYG",
  "YHYY",
  "YI51",
  "YI52",
  "YI54",
  "YI55",
  "YI56",
  "YI57",
  "YI61",
  "YI62",
  "YI64",
  "YI65",
  "YI66",
  "YI67",
  "YKBG",
  "YKBH",
  "YKBT",
  "YKBU",
  "YKBY",
  "YKBZ",
  "YKDG",
  "YKDY",
  "YKHY",
  "YKJG",
  "YKJY",
  "YKKG",
  "YKLG",
  "YKNG",
  "YKNH",
  "YKNY",
  "YKPG",
  "YKQG",
  "YKSG",
  "YKSH",
  "YKSU",
  "YKXG",
  "YKXY",
  "YKYG",
  "YKYY",
  "YM51",
  "YM52",
  "YM56",
  "YM57",
  "YM58",
  "YM59",
  "YM61",
  "YM62",
  "YM66",
  "YM67",
  "YM68",
  "YM69",
  "YOM0",
  "YOM1",
  "YON",
  "YONG",
  "YONY",
  "YONZ",
  "YOP",
  "YOPG",
  "YR50",
  "YR53",
  "YR59",
  "YR60",
  "YR63",
  "YR69",
  "YRN",
  "YRNG",
  "YRNU",
  "YRNV",
  "YRNY",
  "YRNZ",
  "YRP",
  "YRPG",
  "YRPU",
  "YRU",
  "YRX",
  "YRXG",
  "YRXU",
  "YRXV",
  "YRXY",
  "YRXZ",
  "YS50",
  "YS53",
  "YS59",
  "YS60",
  "YS63",
  "YS69",
  "YSA",
  "YSB",
  "YSBG",
  "YSBY",
  "YSBZ",
  "YSH",
  "YSHG",
  "YSHY",
  "YSHZ",
  "YSI",
  "YSIG",
  "YSLG",
  "YSP",
  "YSPG",
  "YSS",
  "YSSG",
  "YST",
  "YSTG",
  "YSTR",
  "YSTU",
  "YSTV",
  "YSTY",
  "YSTZ",
  "YSU",
  "YSUG",
  "YSUU",
  "YSUV",
  "YSUY",
  "YSUZ",
  "YSW",
  "YSWG",
  "YSX",
  "YSXG",
  "YSXY",
  "YSXZ",
  "YSY",
  "YSYG",
  "YSYU",
  "YSYV",
  "YSYY",
  "YSYZ",
  "YT51",
  "YT52",
  "YT53",
  "YT54",
  "YT55",
  "YT56",
  "YT57",
  "YT61",
  "YT62",
  "YT64",
  "YT65",
  "YT66",
  "YT67",
  "YTNG",
  "YXW",
  "YXWD",
  "YXWG",
  "YZBG",
  "YZBH",
  "YZBU",
  "YZBY",
  "YZPG",
  "YZSG",
  "YZSH",
  "YZSU",
  "YZWG",
  "YZXG",
  "YZXY",
  "YZYG",
  "YZYY",
  "ZABG",
  "ZABY",
  "ZABZ",
  "ZAD",
  "ZAE",
  "ZAEG",
  "ZAG2",
  "ZAGC",
  "ZAGN",
  "ZAH1",
  "ZAH2",
  "ZAKG",
  "ZAM0",
  "ZAM1",
  "ZAM2",
  "ZAM3",
  "ZAMF",
  "ZAN",
  "ZANI",
  "ZANN",
  "ZANP",
  "ZANY",
  "ZANZ",
  "ZAP",
  "ZAPG",
  "ZAQ",
  "ZAQG",
  "ZASG",
  "ZASY",
  "ZASZ",
  "ZAT",
  "ZAW",
  "ZAWA",
  "ZAWG",
  "ZAX",
  "ZAXG",
  "ZAXY",
  "ZAXZ",
  "ZAY",
  "ZAYG",
  "ZAYY",
  "ZAYZ",
  "ZBT",
  "ZBW",
  "ZBWG",
  "ZBX",
  "ZBXG",
  "ZBXY",
  "ZBXZ",
  "ZBY",
  "ZBYG",
  "ZBYY",
  "ZBYZ",
  "ZC",
  "ZC",
  "ZC2W",
  "ZCB",
  "ZCBG",
  "ZCBY",
  "ZCBZ",
  "ZCC",
  "ZCCG",
  "ZCE",
  "ZCEG",
  "ZCFU",
  "ZCK",
  "ZCKG",
  "ZCMF",
  "ZCN",
  "ZCNG",
  "ZCNY",
  "ZCNZ",
  "ZCP",
  "ZCPG",
  "ZCQ",
  "ZCQG",
  "ZCW",
  "ZCWA",
  "ZCWG",
  "ZCX",
  "ZCXG",
  "ZCXY",
  "ZCXZ",
  "ZCY",
  "ZCYG",
  "ZCYY",
  "ZCYZ",
  "ZDA0",
  "ZDAA",
  "ZDW",
  "ZDWG",
  "ZDX",
  "ZDXG",
  "ZDXY",
  "ZDXZ",
  "ZDY",
  "ZDYG",
  "ZDYY",
  "ZDYZ",
  "ZEAA",
  "ZECB",
  "ZECF",
  "ZECK",
  "ZECR",
  "ZEFU",
  "ZEN1",
  "ZENN",
  "ZERD",
  "ZETR",
  "ZEVG",
  "ZFG2",
  "ZG1N",
  "ZG2W",
  "ZG2X",
  "ZG3N",
  "ZGN",
  "ZGN1",
  "ZGTX",
  "ZHN",
  "ZKAA",
  "ZKAN",
  "ZKAX",
  "ZKBB",
  "ZKBN",
  "ZKBX",
  "ZKEE",
  "ZKEN",
  "ZKEX",
  "ZKKY",
  "ZKLB",
  "ZKLK",
  "ZKLL",
  "ZKLN",
  "ZKLP",
  "ZKLS",
  "ZKLX",
  "ZKLY",
  "ZKNF",
  "ZKOD",
  "ZKRY",
  "ZKSB",
  "ZKSL",
  "ZKSM",
  "ZKSN",
  "ZKSS",
  "ZKZB",
  "ZKZK",
  "ZKZN",
  "ZKZS",
  "ZKZY",
  "ZL1N",
  "ZL2N",
  "ZL2T",
  "ZL2W",
  "ZL2X",
  "ZL3N",
  "ZLRG",
  "ZLTX",
  "ZMRB",
  "ZMRL",
  "ZODG",
  "ZODM",
  "ZOGR",
  "ZOI1",
  "ZOIR",
  "ZOT",
  "ZOW",
  "ZOX",
  "ZOXG",
  "ZOXZ",
  "ZOY",
  "ZOYZ",
  "ZPA1",
  "ZPAC",
  "ZPAK",
  "ZPAR",
  "ZPKR",
  "ZPMF",
  "ZPO1",
  "ZPO2",
  "ZPOG",
  "ZPOR",
  "ZQN",
  "ZQS",
  "ZQX",
  "ZRC1",
  "ZRE1",
  "ZREF",
  "ZREG",
  "ZRN",
  "ZROD",
  "ZROG",
  "ZSA",
  "ZSAG",
  "ZSAS",
  "ZSB",
  "ZSBG",
  "ZSEB",
  "ZSEG",
  "ZSEL",
  "ZSEN",
  "ZSER",
  "ZSES",
  "ZSL",
  "ZSLG",
  "ZSM",
  "ZSMG",
  "ZSN",
  "ZSNG",
  "ZSR",
  "ZSR1",
  "ZSR2",
  "ZSRN",
  "ZSS",
  "ZSSG",
  "ZSTX",
  "ZSVG",
  "ZT01",
  "ZT02",
  "ZT03",
  "ZT07",
  "ZT08",
  "ZT09",
  "ZT21",
  "ZT22",
  "ZT27",
  "ZT29",
  "ZT51",
  "ZT52",
  "ZT53",
  "ZT54",
  "ZT55",
  "ZT56",
  "ZT57",
  "ZT58",
  "ZT61",
  "ZT62",
  "ZT64",
  "ZT65",
  "ZT66",
  "ZT67",
  "ZT68",
  "ZTAB",
  "ZTAK",
  "ZTAS",
  "ZTSI",
  "ZTSP",
  "ZUC",
  "ZUC",
  "ZUCI",
  "ZUCK",
  "ZUCN",
  "ZUCP",
  "ZUCR",
  "ZUG1",
  "ZUGN",
  "ZUK",
  "ZUN",
  "ZUPK",
  "ZUPR",
  "ZUR",
  "ZUR1",
  "ZURK",
  "ZURN",
  "ZVCN",
  "ZVCX",
  "ZVT",
  "ZVX",
  "ZVXG",
  "ZVY",
  "ZWA0",
  "ZW01",
  "ZW03",
  "ZWA0",
  "ZWAB",
  "ZWAC",
  "ZWAK",
  "ZWAS",
  "ZWBZ",
  "ZWC",
  "ZWC",
  "ZWCB",
  "ZWCP",
  "ZWE",
  "ZWEB",
  "ZWER",
  "ZWES",
  "ZWH1",
  "ZWH2",
  "ZWL",
  "ZWM0",
  "ZWM1",
  "ZWM2",
  "ZWM3",
  "ZWMF",
  "ZWN",
  "ZWNZ",
  "ZWP",
  "ZWQ",
  "ZWRG",
  "ZWSZ",
  "ZWT",
  "ZWW",
  "ZWX",
  "ZWXZ",
  "ZWY",
  "ZWYZ",
  "ZXAD",
  "ZYX",
  "ZYXG",
  "ZYY",
  "ZYYG",
  "ZZT",
  "ZZX",
  "ZZXG",
  "ZZY",
  "ZZYG",
];
